import FaceTecSDK, { FaceTecFaceScanProcessor } from "facetec-sdk";

export type Effect = { blob: string } | undefined;

export type LivenessData = {
  faceScan: string;
  auditTrailImage: string;
  lowQualityAuditTrailImage: string;
};

export type LivenessDataHandler = (
  livenessData: LivenessData,
) => Promise<Effect>;
type MakeProcessorProps = {
  handleLivenessData: LivenessDataHandler;
  onDone: () => void;
  onError: (error: Error) => void;
};

const makeProcessor = (props: MakeProcessorProps): FaceTecFaceScanProcessor => {
  const { handleLivenessData, onDone, onError } = props;
  const handleError = (error: Error) => {
    console.log(error);
    onError(error);
  };
  const process: FaceTecFaceScanProcessor["processSessionResultWhileFaceTecSDKWaits"] =
    (sessionResult, effect) => {
      console.log(sessionResult);

      const { faceScan, status } = sessionResult;

      if (
        status !== FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully
      ) {
        const friendlyStatus =
          FaceTecSDK.getFriendlyDescriptionForFaceTecSessionStatus(status);
        const error = new Error(
          `Session was not completed successfully, cancelling.  \
          Status: ${friendlyStatus} (${status})`,
        );
        handleError(error);
        effect.cancel();
        return;
      }

      if (!faceScan) {
        throw new Error("Expected face scan to be present");
      }

      handleLivenessData({
        faceScan,
        auditTrailImage: sessionResult.auditTrail[0] || "",
        lowQualityAuditTrailImage: sessionResult.lowQualityAuditTrail[0] || "",
      }).then(
        (variant) => {
          if (!variant) return effect.cancel();

          return effect.proceedToNextStep(variant.blob);
        },
        (error) => {
          handleError(error);
          effect.cancel();
        },
      );
    };

  return {
    onFaceTecSDKCompletelyDone: onDone,
    processSessionResultWhileFaceTecSDKWaits: process,
  } as FaceTecFaceScanProcessor;
};

export default makeProcessor;
